import EmptyView1 from '../../layouts/EmptyView1'
import CreateAccount from './CreateAccount'

export default EmptyView1(CreateAccount)
